import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import {
  AgendaEvent,
  AgendaEventType,
  AgendaEventTypeObjectNature,
  CalendarEventInfo,
} from '@cropx-common/models/CalendarEventsModel';
import { TimeUtils } from '@cropx-common/services/TimeUtils';
import { UserPropsService } from '@cropx-common/services/local-storage/UserPropsService';
import { UnitFormatterService } from '@cropx-common/services/local-storage/measurement.service';
import { TranslateService } from '@ngx-translate/core';

export class EventHelper {
  static editableEvents = [
    AgendaEventType.Rainfall,
    AgendaEventType.Custom,
    AgendaEventType.FlowMeters,
    AgendaEventType.Scouting,
    AgendaEventType.Spray,
    AgendaEventType.FertilizerApplication,
    AgendaEventType.IrrigationApplied,
  ];

  static getEventStyle(
    type: AgendaEventType,
    objectNature?: AgendaEventTypeObjectNature,
  ): EventStyle {
    switch (type) {
      case AgendaEventType.ETService:
      case AgendaEventType.ETServiceForecast:
        return {
          textColor: '!text-black-900',
          backgroundColor: '!bg-black-50',
          borderColor: '!border-black-50',
          icon: 'cxi-check',
        };
      case AgendaEventType.IrrigationRecommendation:
        return {
          textColor: '!text-salmon-600',
          backgroundColor: '!bg-salmon-50',
          borderColor: '!border-salmon-50',
          icon: 'cxi-grower',
        };
      case AgendaEventType.RecommendationDate:
        return {
          textColor: '!text-salmon-600',
          backgroundColor: '!bg-salmon-50',
          borderColor: '!border-salmon-50',
          icon: '!cxi-grower',
        };
      case AgendaEventType.FertilizerApplication:
        return {
          textColor: '!text-teal-900',
          backgroundColor: '!bg-teal-100',
          borderColor: '!border-teal-100',
          icon: 'cxi-nutrition',
        };
      case AgendaEventType.RainfallService:
      case AgendaEventType.RainfallServiceForecast:
        return {
          textColor: '!text-purple-600',
          backgroundColor: '!bg-purple-50',
          borderColor: '!border-purple-50',
          icon: 'cxi-light-rain',
        };
      case AgendaEventType.RainfallWeatherStation:
        return {
          textColor: '!text-blue-600',
          backgroundColor: '!bg-blue-50',
          borderColor: '!border-blue-50',
          icon: 'cxi-light-rain',
        };
      case AgendaEventType.PivotIrrigationAppliedService:
        return {
          textColor: '!text-purple-600',
          backgroundColor: '!bg-purple-50',
          borderColor: '!border-purple-50',
          icon: 'cxi-semi-circle',
        };
      case AgendaEventType.Rainfall:
        return {
          textColor: '!text-blue-600',
          backgroundColor: '!bg-blue-50',
          borderColor: '!border-blue-50',
          icon: 'cxi-light-rain',
        };
      case AgendaEventType.Spray:
        return {
          textColor: '!text-teal-900',
          backgroundColor: '!bg-teal-100',
          borderColor: '!border-teal-100',
          icon: 'cxi-spray',
        };
      case AgendaEventType.IrrigationApplied:
        return {
          textColor: '!text-teal-900',
          backgroundColor: '!bg-teal-100',
          borderColor: '!border-teal-100',
          icon: 'cxi-droplets',
        };
      case AgendaEventType.IrrigationAsAppliedService:
        if (
          objectNature === AgendaEventTypeObjectNature.TalgilAsAppliedIrrigation
        ) {
          return {
            textColor: '!text-teal-900',
            backgroundColor: '!bg-teal-100',
            borderColor: '!border-teal-100',
            icon: 'cxi-valve',
          };
        }
        if (
          objectNature === AgendaEventTypeObjectNature.WiseconnAsAppliedEvent
        ) {
          return {
            textColor: '!text-teal-900',
            backgroundColor: '!bg-teal-100',
            borderColor: '!border-teal-100',
            icon: 'cxi-droplets',
          };
        }
        if (
          objectNature ===
          AgendaEventTypeObjectNature.PivotIrrigationAppliedEventCalendarEvent
        ) {
          return {
            textColor: '!text-purple-600',
            backgroundColor: '!bg-purple-50',
            borderColor: '!border-purple-50',
            icon: 'cxi-semi-circle',
          };
        }
        return {
          textColor: '!text-teal-900',
          backgroundColor: '!bg-teal-100',
          borderColor: '!border-teal-100',
          icon: 'cxi-valve',
        };

      case AgendaEventType.PlantingDate:
        return {
          textColor: '!text-teal-900',
          backgroundColor: '!bg-teal-100',
          borderColor: '!border-teal-100',
          icon: 'cxi-planting',
        };
      case AgendaEventType.EmergenceDate:
        return {
          textColor: '!text-teal-900',
          backgroundColor: '!bg-teal-100',
          borderColor: '!border-teal-100',
          icon: 'cxi-sprout',
        };
      case AgendaEventType.Custom:
        return {
          textColor: '!text-teal-900',
          backgroundColor: '!bg-teal-100',
          borderColor: '!border-teal-100',
          icon: 'cxi-glasses',
        };
      case AgendaEventType.SensorInstallationDate:
        return {
          textColor: '!text-black-900',
          backgroundColor: '!bg-black-100',
          borderColor: '!border-black-50',
          icon: 'cxi-cropx-sensor',
        };

      case AgendaEventType.Scouting:
        return {
          textColor: '!text-teal-900',
          backgroundColor: '!bg-teal-100',
          borderColor: '!border-teal-100',
          icon: 'cxi-glasses',
        };
      case AgendaEventType.FlowMeters:
        return {
          textColor: '!text-teal-900',
          backgroundColor: '!bg-teal-100',
          borderColor: '!border-teal-100',
          icon: 'cxi-valve',
        };
      case AgendaEventType.FertigationAsAppliedService:
        return {
          textColor: '!text-teal-900',
          backgroundColor: '!bg-teal-100',
          borderColor: '!border-teal-100',
          icon: 'cxi-nutrition',
        };
      default:
        return {
          textColor: '!text-teal-900',
          backgroundColor: '!bg-teal-100',
          borderColor: '!border-teal-100',
          icon: 'cxi-droplets',
        };
    }
  }

  static isIrrigationEvent(event: AgendaEvent): boolean {
    switch (event.type) {
      case AgendaEventType.IrrigationRecommendation:
      case AgendaEventType.IrrigationApplied:
      case AgendaEventType.PivotIrrigationAppliedService:
      case AgendaEventType.Rainfall:
      case AgendaEventType.RainfallWeatherStation:
      case AgendaEventType.RainfallServiceForecast:
      case AgendaEventType.RainfallService:
      case AgendaEventType.IrrigationAsAppliedService:
        return true;
      default:
        return false;
    }
  }

  static getEventName(
    type: AgendaEventType,
    t: TranslateService,
    objectNature: AgendaEventTypeObjectNature = null,
  ): string {
    switch (type) {
      case AgendaEventType.ETService:
        return AgendaEventType.ETService;
      case AgendaEventType.ETServiceForecast:
        return AgendaEventType.ETServiceForecast;
      case AgendaEventType.IrrigationRecommendation:
        return t.instant(_('Irrigation (Recommendation)'));
      case AgendaEventType.RecommendationDate:
        return t.instant(_('Recommendation'));
      case AgendaEventType.FertilizerApplication:
        return t.instant(_('Fertilization'));
      case AgendaEventType.RainfallService:
        return t.instant(_('Rainfall (Weather service)'));
      case AgendaEventType.RainfallServiceForecast:
        return t.instant(_('Rainfall (Forecast)'));
      case AgendaEventType.RainfallWeatherStation:
        return t.instant(_('Rainfall (Rain gauge)'));
      case AgendaEventType.PivotIrrigationAppliedService:
        if (
          objectNature ===
          AgendaEventTypeObjectNature.PivotIrrigationAppliedEventCalendarEvent
        ) {
          return t.instant(_('Irrigation (Reinke)'));
        }
        return t.instant(_('Irrigation'));
      case AgendaEventType.Rainfall:
        return t.instant(_('Rainfall (Manual)'));
      case AgendaEventType.Spray:
        return t.instant(_('Spraying'));
      case AgendaEventType.IrrigationApplied:
        return t.instant(_('Irrigation (Manual)'));
      case AgendaEventType.IrrigationAsAppliedService:
        if (
          objectNature === AgendaEventTypeObjectNature.TalgilAsAppliedIrrigation
        ) {
          return t.instant(_('Irrigation (Tal gil)'));
        }
        if (
          objectNature === AgendaEventTypeObjectNature.WiseconnAsAppliedEvent
        ) {
          return t.instant(_('Irrigation (WiseConn)'));
        }
        if (
          objectNature ===
          AgendaEventTypeObjectNature.PivotIrrigationAppliedEventCalendarEvent
        ) {
          return t.instant(_('Irrigation (Reinke)'));
        }
        return t.instant(_('Irrigation'));
      case AgendaEventType.PlantingDate:
        return t.instant(_('Planting date'));
      case AgendaEventType.EmergenceDate:
        return t.instant(_('Emergence'));
      case AgendaEventType.Custom:
        return AgendaEventType.Custom;
      case AgendaEventType.SensorInstallationDate:
        return t.instant(_('Sensor installed'));
      case AgendaEventType.Scouting:
        return t.instant(_('Scouting'));
      case AgendaEventType.FlowMeters:
        return t.instant(_('Flow meter (Manual)'));
      case AgendaEventType.FertigationAsAppliedService:
        return t.instant(_('WiseConn Fertilization'));
    }
  }

  static getEventDisplayValue(
    event: CalendarEventInfo,
    userPropsService: UserPropsService,
    unitFormat: UnitFormatterService,
  ): string {
    const type = event.type;
    const objectNature = event.objectNature;
    switch (type) {
      case AgendaEventType.FertigationAsAppliedService:
        return unitFormat.volume(event.amount);
      case AgendaEventType.IrrigationAsAppliedService:
        if (
          objectNature === AgendaEventTypeObjectNature.WiseconnAsAppliedEvent
        ) {
          return unitFormat.volume(event.amount);
        } else {
          return unitFormat.irrigation(event.amount);
        }
      case AgendaEventType.ETService:
      case AgendaEventType.ETServiceForecast:
      case AgendaEventType.IrrigationRecommendation:
      case AgendaEventType.Rainfall:
      case AgendaEventType.RainfallService:
      case AgendaEventType.RainfallServiceForecast:
      case AgendaEventType.RainfallWeatherStation:
      case AgendaEventType.PivotIrrigationAppliedService:
      case AgendaEventType.IrrigationApplied:
        return unitFormat.irrigation(event.amount);
      case AgendaEventType.FertilizerApplication: {
        const fertilizerUnits = userPropsService.getFertilizerUnits();
        const unit = fertilizerUnits.find(
          (u) => u.code === event.measurementUnitName,
        )?.unit;

        return unitFormat.productDosage(event.amount, unit);
      }
      case AgendaEventType.Spray:
      case AgendaEventType.PlantingDate:
      case AgendaEventType.EmergenceDate:
      case AgendaEventType.Custom:
      case AgendaEventType.SensorInstallationDate:
      case AgendaEventType.Scouting:
      case AgendaEventType.FlowMeters:
        if (event.amount !== null) {
          return unitFormat.irrigation(event.amount);
        }
        return '';
      case AgendaEventType.RecommendationDate:
      default:
        if (event.amount !== null) {
          return unitFormat.productDosage(event.amount, '');
        }
        return '';
    }
  }

  static getEventTimeAsString(eventTime: number): string {
    const date = TimeUtils.format(
      TimeUtils.utcFromMilliseconds(eventTime),
      'YYYY-MM-DD',
    );
    return date;
  }

  static getType(type: string): AgendaEventType | undefined {
    return Object.values(AgendaEventType).includes(type as AgendaEventType)
      ? (type as AgendaEventType)
      : undefined;
  }
}

export type EventStyle = {
  textColor: string;
  backgroundColor: string;
  icon: string;
  borderColor: string;
};
